<!-- feature is a report, report is a feature 🗿 -->

<script setup>
import {computed, onBeforeMount, watch} from 'vue'
import { useGeoStore } from '@/stores/geo'
import {useRouter, useRoute} from 'vue-router'

import PageMapData from './PageMapData.vue'

const geoStore = useGeoStore()
const route = useRoute()
const router = useRouter()

const featureCode = computed(() => route.params.featureCode)
const map = computed(() => geoStore.map)
const draw = computed(() => geoStore.draw)
const feature = computed(() => geoStore.currentFeature)
const isMapReady = computed(() => geoStore.mapReady)

const fetchFeature = async (code) => {
  if (feature.value && feature.value?.properties?.code === code) {
    return
  }

  geoStore.setCurrentFeature({feature: null})

  await geoStore.fetchFeature(code)

  if (!feature.value) {
    router.push({name: 'Dashboard'})
  }
}

onBeforeMount(async () => {
  await fetchFeature(featureCode.value)
})

watch(featureCode, async (code) => {
  await fetchFeature(code)
})
</script>

<template>
  <div :key="featureCode">
    <router-view></router-view>
    <PageMapData v-if="feature && isMapReady && draw" :key="feature.properties.code" :feature="feature" :map="map" :draw="draw" />
  </div>
</template>
